export default "__VITE_ASSET__7YS3QGx9__"